"use strict";

import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'black'
  }
});
//# sourceMappingURL=styles.js.map